class ContactFormConfirmation {
  constructor() {
    this.form = document.querySelector('#ContactForm');
    this.confirmationScreen = document.querySelector('.c-contact-form__confirmation');
    this.inputScreen = document.querySelector('.c-contact-form__input');
    this.confirmButton = document.querySelector('.c-contact-form__confirm-btn');
    this.backButton = document.querySelector('.c-contact-form__back-btn');
    this.submitButton = document.querySelector('.c-contact-form__submit-btn');
    this.termsCheckbox = document.querySelector('#ContactForm-terms');

    if (!this.form) return;

    this.init();
  }

  init() {
    // 確認ボタンのクリックイベント
    this.confirmButton?.addEventListener('click', (e) => {
      e.preventDefault();
      this.showConfirmation();
    });

    // 戻るボタンのクリックイベント
    this.backButton?.addEventListener('click', (e) => {
      e.preventDefault();
      this.showInput();
    });

    // 送信ボタンのクリックイベント
    this.submitButton?.addEventListener('click', (e) => {
      e.preventDefault();
      this.submitForm();
    });

    // 同意チェックボックスの制御
    this.initTermsCheckboxControl();
  }

  /**
   * 必須項目がすべて入力されている場合にのみチェックボックスを有効にする
   */
  initTermsCheckboxControl() {
    if (!this.termsCheckbox) return;

    // チェックボックスのクリックイベントを監視
    this.termsCheckbox.addEventListener('click', (e) => {
      if (!this.areAllRequiredFieldsFilled()) {
        e.preventDefault();
        this.termsCheckbox.checked = false;
        alert('Please fill in all required fields before agreeing to the terms.');
      }
    });
  }

  /**
   * すべての必須フィールドが入力されているかチェック
   */
  areAllRequiredFieldsFilled() {
    const firstname = document.querySelector('#ContactForm-firstname');
    const lastname = document.querySelector('#ContactForm-lastname');
    const email = document.querySelector('#ContactForm-email');
    const phone = document.querySelector('#ContactForm-phone');
    const message = document.querySelector('#ContactForm-body');

    // First name
    if (!firstname?.value?.trim()) return false;

    // Last name
    if (!lastname?.value?.trim()) return false;

    // Email address
    if (!email?.value?.trim()) return false;

    // Email format check
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email?.value)) return false;

    // Phone number
    if (!phone?.value?.trim()) return false;

    // Your message
    if (!message?.value?.trim()) return false;

    return true;
  }

  showConfirmation() {
    // バリデーション
    if (!this.validateForm()) {
      return;
    }

    // 入力値を取得
    const firstname = document.querySelector('#ContactForm-firstname')?.value || '';
    const lastname = document.querySelector('#ContactForm-lastname')?.value || '';
    const company = document.querySelector('#ContactForm-company')?.value || '';
    const email = document.querySelector('#ContactForm-email')?.value || '';
    const phone = document.querySelector('#ContactForm-phone')?.value || '';
    const message = document.querySelector('#ContactForm-body')?.value || '';

    // 確認画面に値を設定
    document.querySelector('.c-contact-form__confirm-firstname').textContent = firstname || '未入力';
    document.querySelector('.c-contact-form__confirm-lastname').textContent = lastname || '未入力';

    // Companyフィールドが存在する場合のみ値を設定
    const companyElement = document.querySelector('.c-contact-form__confirm-company');
    if (companyElement) {
      companyElement.textContent = company || '未入力';
    }

    document.querySelector('.c-contact-form__confirm-email').textContent = email || '未入力';
    document.querySelector('.c-contact-form__confirm-phone').textContent = phone || '未入力';
    document.querySelector('.c-contact-form__confirm-message').textContent = message || '未入力';

    // 画面切り替え
    this.inputScreen.classList.add('is-hidden');
    this.confirmationScreen.classList.remove('is-hidden');

    // ページトップにスクロール
    window.scrollTo({
      top: this.confirmationScreen.offsetTop - 100,
      behavior: 'smooth',
    });
  }

  showInput() {
    // 画面切り替え
    this.confirmationScreen.classList.add('is-hidden');
    this.inputScreen.classList.remove('is-hidden');

    // ページトップにスクロール
    window.scrollTo({
      top: this.inputScreen.offsetTop - 100,
      behavior: 'smooth',
    });
  }

  validateForm() {
    const firstname = document.querySelector('#ContactForm-firstname');
    const lastname = document.querySelector('#ContactForm-lastname');
    const email = document.querySelector('#ContactForm-email');
    const phone = document.querySelector('#ContactForm-phone');
    const message = document.querySelector('#ContactForm-body');
    const terms = document.querySelector('#ContactForm-terms');

    // First nameの必須チェック
    if (!firstname?.value?.trim()) {
      firstname?.focus();
      alert('First name is required.');
      return false;
    }

    // Last nameの必須チェック
    if (!lastname?.value?.trim()) {
      lastname?.focus();
      alert('Last name is required.');
      return false;
    }

    // Email addressの必須チェック
    if (!email?.value?.trim()) {
      email?.focus();
      alert('Email address is required.');
      return false;
    }

    // Email addressの形式チェック
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email?.value)) {
      email?.focus();
      alert('Please enter a valid email address.');
      return false;
    }

    // Phone numberの必須チェック
    if (!phone?.value?.trim()) {
      phone?.focus();
      alert('Phone number is required.');
      return false;
    }

    // Your messageの必須チェック
    if (!message?.value?.trim()) {
      message?.focus();
      alert('Your message is required.');
      return false;
    }

    // 利用規約の同意チェック
    if (!terms?.checked) {
      terms?.focus();
      alert('Please agree to the terms and conditions.');
      return false;
    }

    return true;
  }

  submitForm() {
    // フォームを実際に送信
    this.form.submit();
  }
}

/**
 * サンキューページ（contact_posted=true）の時の表示調整
 */
function adjustThankYouPage() {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('contact_posted') === 'true') {
    // rich-text セクションをすべて非表示にする
    const richTextSections = document.querySelectorAll('.rich-text');
    richTextSections.forEach((section) => {
      section.style.display = 'none';
    });

    // コンタクトフォームセクションのpadding-topを0にする
    const contactSection = document.querySelector('.contact');
    if (contactSection) {
      contactSection.style.paddingTop = '0';
    }
  }
}

// DOMの読み込み完了後に初期化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ContactFormConfirmation();
    adjustThankYouPage();
  });
} else {
  new ContactFormConfirmation();
  adjustThankYouPage();
}
